const {Backbone} = require('backboneAdapter');
import ThisModel from 'js/models/voucher.redemption.model';

require('backbonePaginator');
require('backgrid');
require('backgridPaginator');

export default Backbone.PageableCollection.extend({
    mode: "server",
    model: ThisModel,
    userId: null,
    filters: null,
    state: {
        pageSize: 10,
        firstPage: 0,
        page: 0
    },
    url: function () {
        const filterPart = this.filters ? `?filtersMap=${this.filters}` : "";
        return `/CampaignCloud/ApiUser/${this.userId}/getDetailedRedemptionReport${filterPart}`;
    },
    parse: function (response) {
        if (!response) {
            return [];
        }

        if (response.data && response.data.extras && response.data.extras.isForRedeemers) { //used for Redeemers Tab in Profile.htm
            this.totalPages = Math.ceil(response.data.count / this.state.pageSize);
            this.state.lastPage = this.totalPages - 1;
            this.extras = response.data.extras;
            this.data = response.data.data;
            this.count = response.data.count;

            return response;
        } else {
            if (response.filtered) {
                this.totalPages = Math.ceil(response.voucherReportLength / this.state.pageSize);
            } else {
                this.totalPages = Math.ceil(response.countOfVoucherRedemptionsAndCountOfSubscriptions[0][0] / this.state.pageSize);
            }
            this.state.lastPage = this.totalPages - 1;
            this.extras = response.extras;
            this.count = response.countOfVoucherRedemptionsAndCountOfSubscriptions[0][0];
            this.countContacts = response.countOfSubscriptionIds;
            this.countContactsRedeemed = response.countOfVoucherRedemptionsAndCountOfSubscriptions[0][1];
            this.displayName = response.currentUser;
            this.pointsRedemptions = response.userPointsPerRedemption;
            return response.voucherReport;
        }
    },
    info: function () {
        var info = {
            firstPage: this.state.firstPage,
            page: this.state.currentPage,
            lastPage: this.state.lastPage,
            perPage: this.state.pageSize
        };

        this.information = info;
        return info;
    }
});
